export * from "./confirmation-modal.component";
